import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { HomeIcon, MenuIcon as MenuIconLucide, InfoIcon, PhoneIcon, UserIcon, ShoppingCartIcon, ChevronUpIcon } from 'lucide-react';
const QuickAccess = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };
  return <div className="fixed bottom-6 left-6 z-40" data-id="element-186">
      <div className="flex flex-col items-center" data-id="element-187">
        {/* Expanded menu */}
        {isExpanded && <div className="mb-2 flex flex-col space-y-2" data-id="element-188">
            <Link to="/" className="bg-amber-800 text-white p-3 rounded-full shadow-lg hover:bg-amber-900 transition-all" aria-label="Home" data-id="element-189">
              <HomeIcon className="h-5 w-5" data-id="element-190" />
            </Link>
            <Link to="/menu" className="bg-amber-800 text-white p-3 rounded-full shadow-lg hover:bg-amber-900 transition-all" aria-label="Menu" data-id="element-191">
              <MenuIconLucide className="h-5 w-5" data-id="element-192" />
            </Link>
            <Link to="/about" className="bg-amber-800 text-white p-3 rounded-full shadow-lg hover:bg-amber-900 transition-all" aria-label="About" data-id="element-193">
              <InfoIcon className="h-5 w-5" data-id="element-194" />
            </Link>
            <Link to="/contact" className="bg-amber-800 text-white p-3 rounded-full shadow-lg hover:bg-amber-900 transition-all" aria-label="Contact" data-id="element-195">
              <PhoneIcon className="h-5 w-5" data-id="element-196" />
            </Link>
            <Link to="/login" className="bg-amber-800 text-white p-3 rounded-full shadow-lg hover:bg-amber-900 transition-all" aria-label="Login" data-id="element-197">
              <UserIcon className="h-5 w-5" data-id="element-198" />
            </Link>
            <Link to="/customer" className="bg-amber-800 text-white p-3 rounded-full shadow-lg hover:bg-amber-900 transition-all" aria-label="Cart" data-id="element-199">
              <ShoppingCartIcon className="h-5 w-5" data-id="element-200" />
            </Link>
          </div>}
        {/* Toggle button */}
        <button onClick={toggleExpanded} className="bg-amber-800 text-white p-3 rounded-full shadow-lg hover:bg-amber-900 transition-all flex items-center justify-center" aria-label={isExpanded ? 'Close quick access' : 'Open quick access'} data-id="element-201">
          <ChevronUpIcon className={`h-5 w-5 transition-transform ${isExpanded ? 'rotate-180' : ''}`} data-id="element-202" />
        </button>
      </div>
    </div>;
};
export default QuickAccess;